<template>
  <div class="create">
    <PageBanner>Create Event</PageBanner>
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue'
export default {
  components: {
    PageBanner
  }
}
</script>

<style lang="scss" scoped></style>
